const getSituacaoTributariaFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'tributo',
    label: 'Tributo',
    type: 'select',
    options: drops?.Tributo,
    multiple: true,
    initial: true,
  },
  { name: 'descricao', label: 'Descrição' },
  {
    name: 'cst',
    label: 'CST',
    type: 'number',
  },
];

export default getSituacaoTributariaFilterFields;
